<div class=" p-grid p-ai-center p-jc-around">
    <!-- logo -->
    <div class="p-col-1">
        <a [routerLink]="['/']">
          <img class="img-fluid" [src]="imgDuminval" />
        </a>
    </div>
    <div class="p-col-2">
      <img class="img-fluid" [src]="imgInterreg">
    </div>
    <div class="p-col-1">
      <img class="img-fluid cencylImg" [src]="imgCencyl" />
    </div>
    <div class="p-col-3 p-offset-1">
        <div class="p-d-flex p-ai-end p-jc-end p-flex-wrap">
                <!-- <label for="email" class="p-sr-only">Usuario</label> -->
                <input class="p-mr-2" type="email" pInputText [placeholder]='"GLOBAL.EMAIL" | translate' [(ngModel)]="user.email" />
                <!-- <label for="password" class="p-sr-only">Contraseña</label> -->
                <input class="p-mr-2" type="password" pInputText [placeholder]='"GLOBAL.CONTRASEÑA" | translate' [(ngModel)]="user.password" />
        </div>
    </div>
    <div class="p-col-2 p-formgroup-inline">
        <!-- TBR by register component -->
        <p-button class="sepBut" type="button" label="Entrar" (click)="login()"></p-button>
        <p-button type="button" label="Registrarse" (click)="registrarPublico()"></p-button>
        <p-button class="p-ml-1 p-mt-2 w-75" type="button" label="Recuperar contraseña" (click)="restartPasword()"></p-button>
        <!-- ENDS register component -->
    </div>
</div>
<dum-toast #dumToast></dum-toast>
<div class="delim"></div>
